import * as React from 'react';
import { LinkInterface } from '../../interfaces';
import { Link } from 'react-router-dom';

export const DropdownItem: React.FC<LinkInterface> = ({ children, to }) => (
  <Link className="dropdown-item" to={to}>
    {children}
  </Link>
);
